"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class DebugBrowserDriver {
    constructor() {
        this.name = 'DebugBrowserDriver';
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.debug('[Trackify] Method `load` called.');
            return true;
        });
    }
    supportsEvent(event) {
        console.debug('[Trackify] Method `supportsEvent` called.', event.name, event.getData());
        return true;
    }
    track(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.debug('[Trackify] Method `track` called.', event.name, event.getData());
        });
    }
}
exports.default = DebugBrowserDriver;
//# sourceMappingURL=debug.browser-driver.js.map